import React from 'react'
import { List as MuiList, ListProps } from '@mui/material'

type PropsType = ListProps

export const List = (props: PropsType) => {
	return <MuiList {...props}>{props.children}</MuiList>
}
